import Flickity from 'flickity'
import n2a from './nodelisttoarray.js'

export default function () {
  var elem = n2a(document.querySelectorAll('.photo-carousel'))

  if (elem.length) {
    elem.map((el) => {
      new Flickity(el, {
        cellAlign: 'center',
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true,
        setGallerySize: false
      })
    })
  }
}
